import ChevronUp from '../src/ChevronUp/index';
export default ChevronUp;
